import { isFunction } from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component<ActionList>({})
export default class ActionList extends Vue {
  //#region @Props
  /**
  * ie.
  * @Prop()
  * protected user!: User
  */

  @Prop()
  protected title!: string;

  @Prop()
  protected items!: ActionItem[];
  //#endregion


  //#region @Refs
  /**
  * ie.
  * @Ref()
  * readonly anotherComponent!: AnotherComponent
  */
  //#endregion


  //#region Class properties
  /**
  * ie.
  * protected isLoading = true;
  * * protected company: Company | null = null;
  */
  //#endregion


  //#region Lifecycle Hooks / Init
  /**
  * ie.
  * protected mounted(): void {
  *  console.log('MyComponent has Mounted');
  * }
  */

  protected mounted() {
    //
  }
  //#endregion


  //#region Class methods
  /**
  * ie.
  * protected toggleLoading(): void {
  *  this.isLoading = ! this.isLoading;
  * }
  */

  protected isHidden(item: ActionItem) {
    if (item.hidden === undefined) {
      return false;
    }

    if (isFunction(item.hidden)) {
      return item.hidden(item);
    }

    return item.hidden;
  }
  //#endregion


  //#region Async methods
  /**
  * ie.
  * protected async fetchUserCompany(): Promise<void> {
  *  this.company = await new Company().filter({user: this.user.id}).all();
  * }
  */
  //#endregion


  //#region Getters & Setters
  /**
  * ie.
  * protected get companyName(): string {
  *  return this?.company.name || 'N/A';
  * }
  */
  //#endregion


  //#region @Watchers
  /**
  * ie.
  * @Watch('company')
  * protected companyChanged() {
  *  console.log('Company Changed') ;
  * }
  */
  //#endregion
}

export interface ActionItem {
  icon?: string;
  label: string;
  action: () => void;
  hidden?: boolean | ((item: ActionItem) => boolean);
}
